import { useCurrentOrg } from "~/providers/GraphqlProvider";
import { useOrgConfig } from "~/providers/OrgConfigProvider";
import { Permission, useHasPermission } from "./permissions";
import { filterOutUndefined } from "~/utils/careTeamHelpers";

export default function useDefaultServiceLines() {
  const { serviceLines, loading } = useOrgConfig();
  const currentOrg = useCurrentOrg();

  if (loading || !currentOrg) {
    return [];
  }

  const serviceLineIds = (currentOrg.serviceLineIds || []).filter(id => serviceLines[id]);

  if (serviceLineIds.length === Object.keys(serviceLines).length) {
    return []
  }

  return serviceLineIds;
}

export function useSelectableServiceLineIds() {
  const currentOrg = useCurrentOrg();
  const { serviceLines } = useOrgConfig();

  if (useHasPermission(Permission.impersonateAnyProvider)) {
    return Object.values(serviceLines).map(sl => sl?.id).filter(filterOutUndefined)
  }

  return currentOrg?.serviceLineIds || [];
}
